import { ACTIONS } from "app/store/actions"
import { Action } from "redux"
import { IUserTag } from "user-tag/model"

export interface ITagActionAddUserTag extends Action {
  userTag: IUserTag
}

export interface ITagActionDeleteUserTag extends Action {
  userTagId: number
}

export const tagActionCreator = {
  addUserTag(userTag: IUserTag): ITagActionAddUserTag {
    return {
      type: ACTIONS.TAG_ADD_USER_TAG,
      userTag
    }
  },
  deleteUserTag(userTagId: number): ITagActionDeleteUserTag {
    return {
      type: ACTIONS.TAG_DELETE_USER_TAG,
      userTagId
    }
  }
}
